import Permissions from '@/permissions'
import List from '../../views/borrows/clients/List'
import Show from '../../views/borrows/clients/Show'
import Edit from '../../views/borrows/clients/Edit'
import Client from '../../views/borrows/clients/Index'
import NewLoan from '../../views/borrows/clients/NewLoan'
import ChangeBorrowerId from '../../views/borrows/clients/ChangeBorrowerId'
import SwitchTableColumn from '@/views/borrows/clients/SwitchTableColumn'
import UploadLoanAndCollectionOfficer from '@/views/borrows/clients/UploadLoanAndCollectionOfficer'

export const clientRouters = {
  path: 'client',
  name: 'client',
  component: Client,
  redirect: 'client',
  meta: {
    permissions: [Permissions.backend.client.manage],
    groups: 'client'
  },
  children: [
    {
      path: '',
      name: 'list-client',
      component: List,
      meta: {
        permissions: [Permissions.backend.client.list],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'upload-loan-and-collection-officer',
      name: 'upload-loan-and-collection-officer',
      component: UploadLoanAndCollectionOfficer,
      meta: {
        permissions: [Permissions.backend.client.uploadLoanAndCollectionOfficer],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'Upload Loan and Collection Officer',
            name_km: 'ផ្ទុកឡើងមន្រ្តីទទួលបន្ទុកមើលនិងប្រមូលប្រាក់'
          }
        ]
      }
    },
    {
      path: 'show/:borrow_id',
      name: 'show-client',
      component: Show,
      meta: {
        permissions: [Permissions.backend.client.show],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    },
    {
      path: 'edit/:borrow_id',
      name: 'edit-client',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.client.edit],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'create-loan/:borrowerId',
      name: 'create-loan',
      component: NewLoan
    },
    {
      path: 'change-borrower-id/:borrow_id',
      name: 'change-borrower-id',
      component: ChangeBorrowerId,
      meta: {
        permissions: [Permissions.backend.client.changeBorrowerId],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'Change Borrower ID',
            name_km: 'កែសម្រួលលេខសម្គាល់អតិថិជន'
          }
        ]
      }
    },
    {
      path: 'switch-table-column-client',
      name: 'switch-table-column-client',
      component: SwitchTableColumn,
      meta: {
        permissions: [Permissions.backend.client.filterColumnTable],
        groups: 'client',
        breadcrumb: [
          {
            name_en: 'Client',
            name_km: 'អតិថិជន'
          },
          {
            name_en: 'Switching table columns',
            name_km: 'ផ្លាស់ប្តូរព័ត៌មាននៃតារាង'
          }
        ]
      }
    }
  ]
}
